export default __webpack_public_path__ + "static/media/element_65.9cb83cd8.jpg";